// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"AddOrEditCleanKind--next-sr-only--1ZDMYPA","loadingWrapper":"AddOrEditCleanKind--loadingWrapper--2DoL4Ik","loadingSpin":"AddOrEditCleanKind--loadingSpin--1oFmYco"};